import { cn } from "@/src/utils/shadcn";
import Image from "next/image";
export interface PartnerProps {
  img: string;
}

export function PartnerCard({ img }: PartnerProps) {
  return (
    <div
      className={cn([
        // General
        "group/service bg-white text-accent-900 transition-transform duration-350 dark:text-white  dark:shadow-none",

        // Layout
        "relative z-1 block h-full overflow-hidden rounded-5 p-6 md:p-4",

        // Fixed height for the card
        "h-[100px]   md:h-[120px]",

        // Hover
        "hover:[transform:translateY(-.5rem)]",
      ])}
    >
      <div className="relative flex justify-center items-center h-full w-full">
        <Image
          src={img}
          alt="Partner"
          className="h-auto p-2"
          fill
          style={{ objectFit: 'contain' }} // Ensures the image scales proportionally
        />
      </div>
      {/* Bottom line animation */}
      <span className="invisible absolute bottom-0 left-0 h-[2px] w-full scale-x-[30%] bg-primary opacity-0 transition-all duration-400 group-hover/service:visible group-hover/service:scale-x-100 group-hover/service:opacity-100"></span>
    </div>
  );
}
